export const PLAN_USAGE_STATUS = {
  ok: { label: 'En buen estado', tone: 'ok' },
  warn: { label: 'Cerca del límite', tone: 'warn' },
  full: { label: 'Límite alcanzado', tone: 'full' },
  unlimited: { label: 'Sin tope mensual', tone: 'unlimited' },
};

export function normalizeDocumentUsage(source = {}) {
  if (!source || typeof source !== 'object') return null;

  const unlimited = Boolean(
    source.unlimited ?? source.planUnlimited ?? (
      source.effectiveLimit == null
      && source.maxDocumentsPerMonth == null
      && source.baseLimit == null
    )
  );

  const used = Number(source.used ?? source.documentosMesUsuario ?? 0) || 0;
  const baseLimit = source.baseLimit ?? source.maxDocumentsPerMonth ?? null;
  const extraDocuments = Number(source.extraDocuments ?? 0) || 0;
  const effectiveLimit = source.effectiveLimit ?? (
    baseLimit != null ? baseLimit + extraDocuments : null
  );

  let percent = source.percent ?? source.planUsagePercent ?? null;
  if (percent == null && effectiveLimit) {
    percent = Math.min(Math.round((used / effectiveLimit) * 100), 100);
  }

  const remaining = effectiveLimit != null ? Math.max(effectiveLimit - used, 0) : null;
  const status = getPlanUsageStatus({ percent, unlimited });

  return {
    used,
    baseLimit,
    extraDocuments,
    effectiveLimit,
    remaining,
    percent: percent ?? 0,
    unlimited,
    resetDate: source.resetDate ?? source.planUsageResetDate ?? null,
    periodLabel: source.periodLabel ?? null,
    status,
  };
}

export function normalizeOcrUsage(source = {}) {
  if (!source || typeof source !== 'object') return null;

  const limit = Number(source.effectiveLimit ?? source.limit ?? source.monthlyLimit ?? 0) || 0;
  const used = Number(source.used ?? 0) || 0;
  const remaining = source.remaining ?? (limit > 0 ? Math.max(limit - used, 0) : null);
  const percent = source.percent ?? (limit > 0 ? Math.min(Math.round((used / limit) * 100), 100) : 0);
  const unlimited = limit <= 0;

  let tone = 'ok';
  if (!unlimited && remaining === 0) tone = 'full';
  else if (!unlimited && percent >= 80) tone = 'warn';

  return {
    used,
    limit,
    remaining,
    percent,
    unlimited,
    resetDate: source.resetDate ?? null,
    tone,
  };
}

export function getPlanUsageStatus({ percent = 0, unlimited = false } = {}) {
  if (unlimited) return PLAN_USAGE_STATUS.unlimited;
  if (percent >= 100) return PLAN_USAGE_STATUS.full;
  if (percent >= 80) return PLAN_USAGE_STATUS.warn;
  return PLAN_USAGE_STATUS.ok;
}

export function formatPlanResetDate(resetDate) {
  if (!resetDate) return null;
  return new Date(`${resetDate}T12:00:00`).toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
  });
}

export function planUsageBarColor(tone, modoOscuro) {
  if (tone === 'full') return '#ef4444';
  if (tone === 'warn') return '#f59e0b';
  return modoOscuro ? '#1F80FF' : '#004AAD';
}

export function planUsageSurfaceClass(tone, modoOscuro) {
  if (tone === 'full') {
    return modoOscuro
      ? 'border-red-800/60 bg-red-950/20'
      : 'border-red-200 bg-red-50/80';
  }
  if (tone === 'warn') {
    return modoOscuro
      ? 'border-amber-800/60 bg-amber-950/20'
      : 'border-amber-200 bg-amber-50/80';
  }
  return modoOscuro
    ? 'border-gray-700 bg-gray-900/60'
    : 'border-gray-200 bg-white';
}
